import config from '@/config'
import campaignAPIs from '../../components/views/Campaign/campaignAPIs'
import apiService from '../../services/apiService'
const campaignServiceBaseURL = config.apiServiceBaseURL.campaign // use of campaign service base url
const state = {
  campaigns: [],
  campaignsCount: 0,
  countries: [],
  campaignVerticals: [],
  campaignDetail: {},
  reports: [],
  bfsLists: [],
  invoiceLists: [],
  updatedReport: false,
  campaignUpdated: false,
  feedbackFormUpdated: false,
  invoiceDeleteSuccess: false,
  consolidateReports: [],
  archiveReports: [],
  cldSignature: '',
  // Campaign COGS
  campaignCogs: [],
  savedCampaignCogs: false,
  // Master lists
  masterLists: [],
  masterListSummary: [],
  savedMasterList: false,
  masterListErr: '',
  // dashboard campaigns
  dashboardCampaigns: [],
  dashboardActivations: [],
  dashboardBriefings: [],
  dashboardPairings: [],
  dashboardDrafts: [],
  dashboardReportings: [],
  savedDashboardStatus: false,
  emailSent: false
}

const actions = {
  /**
   * Get all campaign lists (status filters optional)
   * @param {*} commit
   * @param {Array} statuses
   * @returns
   */
  async getCampaigns ({ commit }, payload = {}) {
    try {
      let filters = payload.filters || {}
      let campaigns = await campaignAPIs.getAllCampaignsNoStatus(filters)
      if (filters && campaigns) {
        if (filters.statuses && filters.statuses.length > 0) {
          campaigns = campaigns.filter(campaign => filters.statuses.includes(Number(campaign.status)))
        }
        if (filters.types) {
          campaigns = campaigns.filter(campaign => filters.types.includes(campaign.campaignType))
        }
        if (filters.type) {
          campaigns = campaigns.filter(campaign => campaign.campaignType === filters.type)
        }
        if (filters.payoutStatus) {
          campaigns = campaigns.filter(campaign => campaign.payoutStatus === filters.payoutStatus)
        }
        if (filters.clientID) {
          campaigns = campaigns.filter(campaign => campaign.clientID === filters.clientID)
        }
      }
      commit('SET_CAMPAIGNS', campaigns)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get paginated campaign lists (filters optional)
   * @param {*} commit
   * @param {Array} filtes
   * @returns
  */
  async paginateCampaigns ({ commit }, payload = {}) {
    try {
      let filters = payload.filters || {}
      let response = await campaignAPIs.paginate(filters)
      commit('SET_CAMPAIGNS', response.campaigns || [])
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Nyein - get campaign detail by campaign id
   * @param {*} commit
   * @param {*} id
   * @returns
   */
  async getCampaignDetail ({ commit }, id) {
    try {
      commit('UNSET_CAMPAIGN_DETAIL')
      let response = await campaignAPIs.getCampaign(id)
      commit('SET_CAMPAIGN_DETAIL', response)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Nyein - get campaign count by status
   * @param {*} commit
   * @param {*} id
   * @returns
  */
  async getCampaignsCountByStatus ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'campaignsCount',
        data: 0
      })
      let response = await apiService.get(campaignServiceBaseURL + `/count/bystatus?status=${payload.status}&archive=${payload.archive}`)
      if (response && response.count) {
        commit('SET_DATA', {
          name: 'campaignsCount',
          data: response.count
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get all campaign vertical lists (filters optional)
   * @param {*} commit
   * @param {Array} filterIds
   * @returns
   */
  async getCampaignVerticals ({ commit }, filterIds = []) {
    try {
      let resp = await campaignAPIs.getAllCampaignVerticals(false)
      if (resp) {
        let verticals = resp.data
        if (filterIds.length > 0) {
          verticals = verticals.filter(v => filterIds.includes(v.id))
        }
        commit('SET_CAMPAIGN_VERTICALS', verticals)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get all country lists (filters optional)
   * @param {*} commit
   * @param {Array} filterIds
   * @returns
  */
  async getCountries ({ commit }, filterIds = []) {
    try {
      let resp = await campaignAPIs.getAllCountries(false)
      if (resp) {
        let countries = resp
        if (filterIds.length > 0) {
          countries = countries.filter(v => filterIds.includes(v.id))
        }
        commit('SET_Countries', countries)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   *
   * @param {*} commit
   * @param {Array} campaignIDs
   * @returns
   */
  async getReportsByCampaignIDs ({ commit }, campaignIDs = []) {
    try {
      let resp = await campaignAPIs.getReportsByCampaignIDs(campaignIDs)
      if (resp) {
        commit('SET_REPORTS', resp)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   *
   * @param {*} commit
   * @param {Array} campaignIDs
   * @returns
   */
  async getReportsByCampaignIDRefresh ({ commit }, payload) {
    try {
      let resp = await campaignAPIs.getReportsByCampaignIDs(payload.campaignIDs, payload.refresh || false)
      if (resp) {
        commit('SET_REPORTS', resp)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
  * get campaign by assigned id
  */
  async getCampaignsByAssignedID({ commit }, formData) {
    try {
      commit('SET_DATA', {
        name: 'campaignsCount',
        data: 0
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/count/by/assigned-id', formData)
      if (resp) {
        commit('SET_DATA', {
          name: 'campaignsCount',
          data: resp.count
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get reports by handle
   * @param {*} commit
   * @param {String} handle
   * @returns
  */
  async getReportsByHandle ({ commit }, handle) {
    try {
      commit('SET_DATA', {
        name: 'reports',
        data: []
      })
      let filters = {
        handle
      }
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(campaignServiceBaseURL + `/reports/data/byhandle?${params}`)
      if (response) {
        if (Array.isArray(response) && response.length) {
          commit('SET_DATA', {
            name: 'reports',
            data: response
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update report by ids
   * @param {*} commit
   * @param {*} data
   * @returns
   */
  async updateReportsByIds ({commit}, data) {
    try {
      commit('UNSET_UPDATED')
      await campaignAPIs.updateReportsByIds(data)
      commit('SET_UPDATED')
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update report handle by platform
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async updateReportHandle ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'updatedReport',
        data: false
      })
      await apiService.post(campaignServiceBaseURL + '/reports/update/handle', data)
      commit('SET_DATA', {
        name: 'updatedReport',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update campaign by ids
   * @param {*} commit
   * @param {*} data
   * @returns
   */
  async updateCampaignByIds ({commit}, data) {
    try {
      commit('UNSET_CAMPAIGN_UPDATED')
      await campaignAPIs.updateCampaignByIds(data)
      commit('SET_CAMPAIGN_UPDATED')
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update client feedback form by ids
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async updateFeedbackFormByIds ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'feedbackFormUpdated',
        data: false
      })
      await apiService.post(campaignServiceBaseURL + '/client-feedback/update-by/ids', data)
      commit('SET_DATA', {
        name: 'feedbackFormUpdated',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get all brand fact sheet lists
   * @param {*} commit
   * @returns
   */
  async getBFSLists ({ commit }) {
    try {
      let brandFactSheets = await campaignAPIs.getAllBrandSheets()
      commit('SET_BFS', brandFactSheets.data)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get all uploaded lists
   * @param {*} commit
   * @returns
   */
  async getUploadedInvoiceLists ({ commit }) {
    try {
      let response = await campaignAPIs.getUploadedInvoiceLists()
      commit('SET_UPLOADED_INVOICE', response.invoices)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Nyein - get payment consolidate report by payload filters
   * @param {*} payload
   * @returns
   */
  async getPaymentConsolidateReport({ commit }, payload = {}) {
    try {
      let response = await campaignAPIs.getPaymentConsolidateReport(payload.filters || {})
      if (response) {
        let filters = payload.filters
        if (filters && filters.archive) {
          commit('UNSET_ARCHIVE_REPORT')
          commit('SET_ARCHIVE_REPORT', response.reports)
        } else {
          commit('UNSET_CONSOLIDATE_REPORT')
          commit('SET_CONSOLIDATE_REPORT', response.reports)
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Nyein - Delete Report Content
   * @param {*} commit
   * @returns
   */
  async deleteReport ({ commit }, payload) {
    try {
      commit('UNSET_UPDATED')
      let params = payload.params || {}
      await campaignAPIs.deleteContentFromReport(payload.id, params)
      commit('SET_UPDATED')
    } catch (err) {
      console.error(err)
      return ''
    }
  },
    /**
   * Nyein - get campaign detail by campaign id
   * @param {*} commit
   * @param {*} id
   * @returns
   */
  async getCldSignature ({ commit }, payload) {
    try {
      let response = await campaignAPIs.getCldSignature(payload.filters || {})
      commit('SET_CLD_SIGNATURE', response)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
    /**
   * Nyein - delete cld by id
   * @param {*} commit
   * @param {*} id
   * @returns
   */
  async deleteCldFile ({ commit }, payload) {
    try {
      await campaignAPIs.deleteCldFile(payload)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * delete invoice by ids
   * @param {*} commit
   * @param {*} data
   * @returns
   */
  async deleteInvoiceByIds ({commit}, payload) {
    try {
      commit('UnsetInvoiceDeleteSuccess')
      await campaignAPIs.bulkDeleteInvoices(payload)
      commit('SetInvoiceDeleteSuccess')
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
  * save campaign master lists table data
  */
  async saveCampaignMasterLists({ commit }, formData) {
    try {
      commit('SET_DATA', {
        name: 'savedMasterList',
        data: false
      })
      commit('SET_DATA', {
        name: 'masterListErr',
        data: ''
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/master-lists/create', formData)
      if (resp.success === false) {
        commit('SET_DATA', {
          name: 'masterListErr',
          data: resp.message
        })
      } else {
        commit('SET_DATA', {
          name: 'savedMasterList',
          data: true
        })
      }
    } catch (err) {
      if (err.response.data) {
        commit('SET_DATA', {
          name: 'masterListErr',
          data: err.response.data
        })
      }
      console.error(err)
      return ''
    }
  },
  /**
  * save campaign active year data
  */
  async updateMasterlistActiveYear({ commit }, formData) {
    try {
      commit('SET_DATA', {
        name: 'savedMasterList',
        data: false
      })
      await apiService.post(campaignServiceBaseURL + '/master-lists/update/active-year', formData)
      commit('SET_DATA', {
        name: 'savedMasterList',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get campaign master lists
   * @param {*} commit
   * @returns
  */
  async getCampaignMasterLists ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'masterLists',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(campaignServiceBaseURL + `/master-lists?${params}`)
      if (response) {
        if (Array.isArray(response) && response.length) {
          commit('SET_DATA', {
            name: 'masterLists',
            data: response
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get campaign master list IO Numbers
   * @param {*} commit
   * @returns
  */
  async getCampaignMasterListsIONumbers ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'masterLists',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(campaignServiceBaseURL + `/master-lists/find-IO?${params}`)
      if (response) {
        if (Array.isArray(response) && response.length) {
          commit('SET_DATA', {
            name: 'masterLists',
            data: response
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
  * link master list with client
  */
  async linkMasterlist({ commit }, data) {
    try {
      commit('SET_DATA', {
        name: 'savedMasterList',
        data: false
      })
      await apiService.post(campaignServiceBaseURL + '/master-lists/link/deal', data)
      commit('SET_DATA', {
        name: 'savedMasterList',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async getMasterListSummary({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'masterListSummary',
        data: null
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/master-lists/summary', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'masterListSummary',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async changeMasterListLock({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'savedMasterList',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/master-lists/change/lock', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'savedMasterList',
          data: true
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async refreshMasterList({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'savedMasterList',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/master-lists/refresh', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'savedMasterList',
          data: true
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async getDashboardReviewMeetings({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'dashboardCampaigns',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/dashboard/reviewmeetings', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'dashboardCampaigns',
          data: resp.campaigns
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async getDashboardRevDate({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'dashboardCampaigns',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/dashboard/review-dates', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'dashboardCampaigns',
          data: resp.campaigns
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get dashboard activation campaigns
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  async getDashboardActivation({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'dashboardActivations',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/dashboard/activation', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'dashboardActivations',
          data: resp.campaigns
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get dashboard campaigns
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  async getDashboardCampaigns({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'dashboardBriefings',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/dashboard/campaigns', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'dashboardBriefings',
          data: resp.campaigns
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get dashboard pairing campaigns
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  async getDashboardPairings({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'dashboardPairings',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/dashboard/pairings', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'dashboardPairings',
          data: resp.campaigns
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get dashboard draft campaigns
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  async getDashboardDrafts({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'dashboardDrafts',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/dashboard/drafts', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'dashboardDrafts',
          data: resp.campaigns
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get dashboard reporting
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  async getDashboardReporting({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'dashboardReportings',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/dashboard/reporting', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'dashboardReportings',
          data: resp.campaigns
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async saveDashboardStatus({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'savedDashboardStatus',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/dashboard/status/update', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'savedDashboardStatus',
          data: resp.campaigns
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async sendCampaignReleaseEmailToAdmin({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'emailSent',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/release/email-admin', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'emailSent',
          data: true
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async getCampaignCogs({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'campaignCogs',
        data: null
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/get/campaign-cogs', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'campaignCogs',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async updateCampaignCogs({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'savedCampaignCogs',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/update/campaign-cogs/collection', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'savedCampaignCogs',
          data: true
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async updateCampaignCogsByCampaignID({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'savedCampaignCogs',
        data: false
      })
      let resp = await apiService.post(campaignServiceBaseURL + '/update/campaign-cogs/by/campaignID', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'savedCampaignCogs',
          data: true
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  }
}

const getters = {
  campaigns: state => state.campaigns,
  campaignVerticals: state => state.campaignVerticals
}

/**
 * Need actions to implement
 */
// const actions = {}

const mutations = {
  SET_CAMPAIGNS(state, data) {
    state.campaigns = data
  },
  SET_CAMPAIGN_VERTICALS(state, data) {
    state.campaignVerticals = data
  },
  SET_CAMPAIGN_DETAIL(state, data) {
    state.campaignDetail = data
  },
  UNSET_CAMPAIGN_DETAIL(state) {
    state.campaignDetail = {}
  },
  SET_REPORTS(state, data) {
    state.reports = data
  },
  SET_BFS(state, data) {
    state.bfsLists = data
  },
  SET_UPLOADED_INVOICE(state, data) {
    state.invoiceLists = data
  },
  SET_UPDATED(state) {
    state.updatedReport = true
  },
  UNSET_UPDATED(state) {
    state.updatedReport = false
  },
  SET_CAMPAIGN_UPDATED(state) {
    state.campaignUpdated = true
  },
  UNSET_CAMPAIGN_UPDATED(state) {
    state.campaignUpdated = false
  },
  SET_CONSOLIDATE_REPORT(state, data) {
    state.consolidateReports = data
  },
  UNSET_CONSOLIDATE_REPORT(state) {
    state.consolidateReports = []
  },
  SET_ARCHIVE_REPORT(state, data) {
    state.archiveReports = data
  },
  UNSET_ARCHIVE_REPORT(state) {
    state.archiveReports = []
  },
  SET_CLD_SIGNATURE(state, data) {
    state.cldSignature = data
  },
  SetInvoiceDeleteSuccess(state) {
    state.invoiceDeleteSuccess = true
  },
  UnsetInvoiceDeleteSuccess(state) {
    state.invoiceDeleteSuccess = false
  },
  SET_Countries(state, data) {
    state.countries = data
  },
  SET_DATA(state, { name, data }) {
    state[name] = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/campaign/index.js